module.exports = __webpack_public_path__ + "static/media/tech.e077c1cc.png";